export enum PathKeysEnum {
  INVENTORY = "inventory",
  STORE_PROMO = "store",
  SALESPERSON = "salesperson",
  SHOP_MONITORING = "shop-monitoring",
  LOYALTY_POINT = "loyalty-point",
  CUSTOMER_TIERS = "customer-tiers",
  INVENTORY_BUNDLING = "inventory/bundling",
  VOUCHERS_LIST = "voucher",
  VOUCHER_DETAIL = "voucher/:id/detail",
  SETTINGS_APPROVALS = "settings/approvals",
}

export default PathKeysEnum;
